<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>부가 서비스</h3>
				<h4>부가서비스에 대해 자세히 <br class="visible-xs">알려드릴게요.</h4>
			</div>
			
			<div style="display: flex;">
				<div class="tab" :class="{ 'active': up_active == 1 }" style="width: 100%;" @click="onUpTab(1)">
					사업자 회원
				</div>
				<div class="tab" :class="{ 'active': up_active == 2 }" style="width: 100%;" @click="onUpTab(2)">
					LCL 화물 운송
				</div>
			</div>
			<el-row v-if="up_active==1">
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 1 }"  @click="onTab(1)">
						포장제거
					</div>
				</el-col>
				<el-col :xs="8" :sm="3">
					<div class="tab" :class="{ 'active': active == 2 }"  @click="onTab(2)">
						검수
					</div>
				</el-col>
				<el-col :xs="8" :sm="3">
					<div class="tab" :class="{ 'active': active == 3 }"   @click="onTab(3)">
						포장
					</div>
				</el-col>
				<el-col :xs="8" :sm="3">
					<div class="tab" :class="{ 'active': active == 4 }" @click="onTab(4)">
						통관
					</div>
				</el-col>
				<el-col :xs="8" :sm="3">
					<div class="tab" :class="{ 'active': active == 5 }" @click="onTab(5)">
						반송
					</div>
				</el-col>
				<el-col :xs="8" :sm="5">
					<div class="tab" :class="{ 'active': active == 6 }" @click="onTab(6)">
						원산지 작업/보관
					</div>
				</el-col>
				<el-col :xs="8" :sm="3">
					<div class="tab" :class="{ 'active': active == 7 }" @click="onTab(7)">
						기타
					</div>
				</el-col>
			</el-row>
			<el-row v-else-if="up_active==2">
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 1 }"  @click="onTab(1)">
						검수
					</div>
				</el-col>
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 2 }"  @click="onTab(2)">
						포장
					</div>
				</el-col>
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 3 }"   @click="onTab(3)">
						원산지 작업/보관
					</div>
				</el-col>
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 4 }" @click="onTab(4)">
						통관
					</div>
				</el-col>
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 5 }" @click="onTab(5)">
						반송
					</div>
				</el-col>
				<el-col :xs="8" :sm="4">
					<div class="tab" :class="{ 'active': active == 6 }" @click="onTab(6)">
						기타
					</div>
				</el-col>
				
			</el-row>
			
			
			<div class="tab-content" v-if="up_active==1&&active==1">
				<div class="tab-title">
					포장제거
				</div>
				<div class="type-card">
					<div class="card-head">1. 포장제거</div>
					<div class="card-body">
						<div class="mt5">●	무료
						<br>도착상품을 포장 시 무료로 의류박스/신발박스/폴리백을 제거하여 드립니다.
						<br>[의류박스 제거] 불필요한 현지 의류 박스를 제거해 드립니다.
						<br>[신발 박스 제거] 불필요한 신발 박스를 제거해 드립니다.
						<br>[폴리백 제거] 불필요한 폴리백들을 제거해 드립니다.
						<br>[영수증 제거] 상품에 동봉되어 도착한 영수증을 제거하여 드립니다.
						</div>
						<div class="mt5">●	신청서에 등록해주신 상품들이 도착하면 요청하신 옵션에 따라 불필요한 현지포장을 제거 후 포장해 드려요.</div>
						<div class="mt5">●	제품 분실/파손 등 우려가 있는 상품들은 현지 포장 제거 없이 발송될 수 있습니다.</div>
						<div class="mt5">●	현지 업무량에 따라 포장 제거가 안될 수 있으며, 이로 인한 배송비 차액은 환불대상이 아닙니다.</div>
					</div>
				</div>			
			</div>
			<div class="tab-content" v-if="up_active==1&&active==2">
				<div class="tab-title">
					검수
				</div>
				<div class="type-card">
					<div class="card-head">1. 검수안함</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	현지에 입고된 택배 박스 도착 사진 1장을 제공해 드려요.</div>
						<div class="mt5">●	상품 도착 전 다른 검수 서비스로 변경 가능해요.</div>
						<div class="mt5">●	상품 도착 후, 정밀검수/추가촬영 서비스만 요청 가능해요.</div>
						<div class="mt5">●	항공 건의 경우 선적불가상품의 선적예방차원의 검수안함을 선택할 수 없습니다.</div>
						<div class="mt5">●	세관 수입 신고된 내용과 달리 허위 기재, 수입 불가 상품 진행 등 발생한 모든 책임은 신청자 본인에게 있습니다.</div>
						
						<div class="mt5" style="font-weight: 600;">●	사진은 이렇게 제공해 드려요.	<br class="visible-xs">
								<span class="link-btn type-2" @click="onCurrentNav('/questionList')">
										바로가기 <i class="el-icon-top-right"></i>
								</span>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 기본검수</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	수량 색상 사이즈 오배송을 기본 검수해 드려요.</div>
						<div class="mt5">●	신청서 당 트래킹번호 5개 이내, 상품 10개 이내에서 기본 검수 후 아이템 당 촬영사진 각 1장씩 최대 10장까지 제공해 드려요.</div>
						<div class="mt5">●	상초과 시 트래킹번호 당 전체 도착사진 1장으로 제공해 드리며 기본검수를 대체합니다.</div>
						<div class="mt5">●	회원님께서 도착 사진을 확인해주세요.</div>
						<div class="mt5">●	회원님께 편의를 위해 제공되는 무료 서비스이므로 보상 대상이 아닙니다.</div>
						<div class="mt5">●	검수 중 이상이 발견되면 회원님께 안내를 드려요.</div>				
						<div class="mt5" style="font-weight: 600;">●	사진은 이렇게 제공해 드려요.	<br class="visible-xs">
								<router-link to="/questionList" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 정밀검수</div>
					<div class="card-body">
						<div class="mt5">●	개당 2,000원</div>
						<div class="mt5">●	삼변합 1.5미터 이상의 상품 개당 4,000원</div>
						<div class="mt5">●	기본검수 외 추가로 오염/스크래치 정밀 검수해 드려요.</div>
						<div class="mt5">●	상품당 3장의 도착 사진 제공합니다.</div>
						<div class="mt5">●	정밀검수 후 제공해드린 3장의 도착 사진으로 정밀검수를 대체합니다.</div>
						<div class="mt5">●	회원님께서 도착 사진을 확인해 주세요.</div>
						<div class="mt5">●	정밀검수 미비로 인한 보상은 정밀검수 비용만 환불합니다.</div>
						<div class="mt5">●	대형화물, 특수포장(목재/마대/이형/압축/완충) 및 크기, 수량 난이도에 따라 추가 요금이 발생됩니다.</div>
						<div class="mt5" style="font-weight: 600;">●	사진은 이렇게 제공해 드려요.	<br class="visible-xs">
								<router-link to="/questionList" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 추가촬영</div>
					<div class="card-body">
						<div class="mt5">●	아이템번호당 1,000원</div>
						<div class="mt5">●	도착 상품의 아이템 번호 1개당 최대 3장까지 촬영해드립니다.</div>
						<div class="mt5">●	스크레치/오염/하자 확인 촬영 요청은 정밀검수 옵션으로 변경됩니다.</div>
						<div class="mt5" style="font-weight: 600;">●	사진은 이렇게 제공해 드려요.	<br class="visible-xs">
								<router-link to="/questionList" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 사이즈 실측</div>
					<div class="card-body">
						<div class="mt5">●	삼변합 1.5m 이내 2,000원</div>
						<div class="mt5">●	초과시 10cm 마다  100원
						<br><span style="color:#888;">예) 실측 1.8m는   2,300원 비용 청구</span>
						</div>
						<div class="mt5">●	상품의 실제 사이즈를 실측해 드려요. 고객센터 1:1 문의 접수</div>
						<div class="mt5">●	대형화물, 특수포장 (목재/마대/이형/압축/완충) 및 크기, 수량 난이도에 따라 추가 요금이 발생됩니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 분리/입고정정 수수료</div>
					<div class="card-body">
						<div class="mt5">●	단순 수량 분리/입고 신청서당 300원</div>
						<div class="mt5">●	옵션/수량 분리/입고 신청서당 500원
						<br><span style="color:#888;">1) 이미 입고된 상품들을 여러 신청서에 재입고 요청주실 경우
						<br>2) 이미 입고된 상품들을 입고 취소 후, 다른 트래킹번호로 수정/재입고하는 경우 부속품포함된 상품은 분리불가합니다.</span>
						</div>
						<div class="mt5">●	분리입고 시 발생할 수 있는 실수는 보상대상이 아닙니다. 고객센터 문의 요청 후 진행가능합니다.</div>
						<!-- <div class="mt5" style="font-weight: 600;">●	비용은 이렇게 청구해 드려요.	<br class="visible-xs">
								<router-link to="/" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div> -->
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 수량 검수</div>
					<div class="card-body">
						<div class="mt5">●	단개당 80원</div>
						<div class="mt5">●	신청서상의 상품 전체원산지 작업 시 수량검수 무료</div>
						<div class="mt5">●	구매 수량이 많을 경우 수량 확인을 해드려요.</div>
						<div class="mt5">●	도착 모델별/색상별 등 요청 사항은 난이도에 따라 추가비용이 발생됩니다.</div>
					</div>
				</div>		
			</div>
			<div class="tab-content" v-if="up_active==1&&active==3">
				<div class="tab-title">
					포장
				</div>
				<div class="type-card">
					<div class="card-head">1. 폴리백 포장</div>
					<div class="card-body">
						<div class="mt5">●	신청서 당 일반형 1장 무료</div>
						<div class="mt5">●	추가 장당 - 일반형 개당 300원 / 중형 개당 500원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 박스포장</div>
					<div class="card-body">
						<div class="mt5">●	박스 포장이 필요하신 경우</div>
						<div class="mt5">●	신청서에 등록해주신 상품들을 박스로 포장해 드려요.</div>
						<div class="mt5">●	삼변의합</div>
						<table class="" border="1" cellspacing="0" style="border-color: #eee;">
							<colgroup>
								<col width="167">
								<col width="167">
							</colgroup>
							<tbody>
							<tr>
								<td>80cm 이하</td>
								<td>500원</td>
							</tr>
							<tr>
								<td>100cm 이하</td>
								<td>1,000원</td>
							</tr>
							<tr>
								<td>120cm 이하</td>
								<td>1,500원</td>
							</tr>
							<tr>
								<td>140cm 이하</td>
								<td>2,000원</td>
							</tr>
							<tr>
								<td>160cm 이하</td>
								<td>2,500원</td>
							</tr>
							<tr>
								<td>160cm 이상</td>
								<td>비용상이</td>
							</tr>
							</tbody>
						</table>
						<div class="mt5">●	배송요청 이후에 박스 포장 요청 시 재포장 옵션으로 변경됩니다.</div>
						<div class="mt5">●	합배송 혹은 도착된 박스의 재활용이 불가할 경우</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 마대포장</div>
					<div class="card-body">
						<div class="mt5">●	장당 2,000원 / 대 3,500원</div>
						<div class="mt5">●	대형, 이형물품 박스포장이 불가한 상품 포장 시 마대포장의 경우 포장이 부실할 경우 상품의 파손/훼손 등이 발생할 수 있어요.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 포장보완</div>
					<div class="card-body">
						<div class="mt5">●	1,500원~</div>
						<div class="mt5">●	완충재(에어캡/에어스틱) 등 제품에 맞게 상품 또는 박스에 완충 포장 보완을 해드려요.</div>
						<div class="mt5">●	<strong>상품 포장보완 :</strong> 뽁뽁이 사용량 1m이내 기본 1,500원 초과10cm당 200원
						<br>에어스틱사용량 1m이내 기본 1,500원 초과10cm당 500원
						<br>예: 완충재사용량 1.2m의 경우 ( 뽁뽁이 진행 시 1,900원 / 에어스틱 진행 시 2,500원 ) 청구됩니다.
						<br>항공 운송의 경우 에어스틱 사용 불가합니다
						</div>
						<div class="mt5">●	파손 및 충격방지가 필요한 상품은 포장보완 신청하셔야 파손 보상 접수가 가능하십니다.</div>
						<div class="mt5">●	별도 요청 사항은 고객센터 문의 요청 후 진행합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 수출용 파렛트</div>
					<div class="card-body">
						<div class="mt5">●	개당 25,000원</div>
						<div class="mt5">●	파렛트 작업이 필요하실 경우</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 랩핑</div>
					<div class="card-body">
						<div class="mt5">●	파렛트 당 5,000원</div>
						<div class="mt5">●	파렛트 이용 시 신청가능합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 밴딩 작업</div>
					<div class="card-body">
						<div class="mt5">●	파렛트 당  3,000원</div>
						<div class="mt5">●	밴딩 작업이 필요하신 경우 작업비용입니다.</div>
						<div class="mt5">●	파렛트 이용 시 신청가능합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">8. 목재 포장</div>
					<div class="card-body">
						<div class="mt5">●	실비</div>
						<div class="mt5">●	부피가 큰 상품 파손 위험이 높은 상품 등을 목재 포장해 드려요.</div>
						<div class="mt5">●	현지 판매처에서 통관이 불가능한 목재 포장으로 도착 시, 해제하여 (해체비용 자동청구) 검역 문제가 없는 목재 포장으로 진행됩니다.</div>
						<div class="mt5">●	제품 크기에 따라 소요 시간과 비용이 달라요.</div>
						<div class="mt5">●	목재 포장 접수 이후에는 포장 취소 접수가 불가합니다.</div>	
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">9. 목재포장제거</div>
					<div class="card-body">
						<div class="mt5">●	도착된 목재 포장 삼변합 1.5m 이내 기준 3,000원</div>
						<div class="mt5">●	추가 10cm 당 500원 청구됩니다.</div>
						<div class="mt5">●	도착된 목재 포장의 경우, 검역 통과 불가한 목재 포장의 경우 제거 후 자동 청구드려요.</div>
						<div class="mt5">●	검역통관 가능 목재 포장은 고객센터 문의로 사전 요청해주시면 제거하지 않습니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">10. 감사템플릿</div>
					<div class="card-body">
						<div class="mt5">●	장당 200원</div>
						<div class="mt5" style="font-weight: 600;">●	감사 템플릿 동봉 서비스	<br class="visible-xs">
								<!-- <router-link to="/" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link> -->
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">11. 환불금지 스티커</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5" style="font-weight: 600;">●	개봉 시 환불 불가 안내 스티커	<br class="visible-xs">
								<!-- <router-link to="/" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link> -->
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">12. 한글설명서</div>
					<div class="card-body">
						<div class="mt5">●	A4 장당 200원</div>
						<div class="mt5">●	한글설명서 동봉 서비스 파일 제공해주셔야 합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">13. 변환어댑터</div>
					<div class="card-body">
						<div class="mt5">●	개당 500원</div>
						<div class="mt5">●	사용 용량 초과 시 화재의 위험이 있습니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">14. OPP비닐봉투</div>
					<div class="card-body">
						<div class="mt5">●	소100원 / 중 150원 / 대 200원</div>
						<div class="mt5">●	포장이 부실한 상품, 분실위험있는 구성품 등 분리포장이 필요한 내부 포장용 자재비용</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">15. 바코드 스티커</div>
					<div class="card-body">
						<div class="mt5">●	각종 바코드 스티커 소형 100원</div>
						<div class="mt5">●	바코드 스티커 부착이 필요하신 경우 바코드 자료를 제공해주셔야 작업 가능합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">16. 멀티 박스포장</div>
					<div class="card-body">
						<div class="mt5">●	박스당 수수료 4,000원</div>
						<div class="mt5">●	신청서가 1개이나 주문해주신 상품의 수량 및 부피에 따라 하나의 포장이 불가할 경우, 2번째 추가 포장부터 포장당 비용 발생합니다.</div>
						<div class="mt5">●	해상 항공 동일 2번째 추가 포장부터 멀티박스 수수료 + 국내 택배 크기에 따른 할증요금이 추가됩니다.	<br class="visible-xs">
								<!-- <router-link to="/" class="link-btn type-2">
									할증요금 보러가기 <i class="el-icon-top-right"></i>
								</router-link> -->
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">17. 재포장</div>
					<div class="card-body">
						<div class="mt5">●	포장당 5,000원</div>
						<div class="mt5">●	배송요청 이후 재포장, 합배송, 반송, 상품 확인 등을 요청하실 경우 포장 완료된 기존 포장을 해체 재포장 하는 비용입니다.</div>
						<div class="mt5">●	고객센터 문의 요청 후 진행합니다.</div>
						<div class="mt5">●	배송비 결제 이후에는 요청 불가합니다.</div>			
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">18. 쿠팡 로켓그로스</div>
					<div class="card-body">
						<div class="mt5">●	파렛트 + 랩핑 30,000원 (쿠팡납품용 Kpp혹은 AJ 파렛트) *사전 고객센터로 문의주세요*</div>
						<div class="mt5">●	바코드 스티커 개당 100원</div>
						<div class="mt5">●	고문서 A4 장당 200원</div>
						<div class="mt5">●	바코드 및 관련 문서는 파일로 제공해 주셔야 합니다. 필요하신 부분만 요청가능합니다.</div>	
						<div class="mt5">●	통관완료 후 한국 내 보관이 필요하실 경우 고객센터로 문의 바랍니다.</div>		
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">19. 인증라벨부착</div>
					<div class="card-body">
						<div class="mt5">●	장당 100원</div>
						<div class="mt5">●	각종 인증스티커 부착이 필요할 경우 라벨 자료를 제공해 주셔야 합니다.</div>		
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">20. 문서출력</div>
					<div class="card-body">
						<div class="mt5">●	각종문서출력 A4 장당 200원</div>
						<div class="mt5">●	각종 문서 출력 비용</div>		
					</div>
				</div>	
			</div>
			<div class="tab-content" v-if="up_active==1&&active==4">
				<div class="tab-title">
					통관
				</div>
				<div class="type-card">
					<div class="card-head">1. 목록통관</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	개인통관부호 이용 시
						<br><span style="color:#888;"> - 자가 사용 $150 이하일 경우</span>
						<br><span style="color:#888;"> - 자가 사용 목적 $150 초과 혹은 목록통관 불가 상품이 있을 경우, 일반통관(간이)로 변경됩니다.</span>
						</div>
						<div class="mt5" style="font-weight: 600;">●	통관 주의사항	<br class="visible-xs">
								<router-link to="/bizCustomsInfo" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 간이통관</div>
					<div class="card-body">
						<div class="mt5">●	3,000원</div>
						<div class="mt5">●	개인통관부호 이용 시
						<br><span style="color:#888;"> - 면세 범위 150$ 초과되거나 목록통관 신고 불가 품목이 있을 경우 간이통관으로 진행됩니다.</span>
						<br><span style="color:#888;"> - $2000 초과 시 관세사 비용 11,000원+세관 창고료 실비 청구됩니다.</span>
						</div>
						<div class="mt5" style="font-weight: 600;">●	통관 주의사항	<br class="visible-xs">
								<router-link to="/bizCustomsInfo" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 사업자 통관</div>
					<div class="card-body">
						<div class="mt5">●	관세사 비용 18,000원 (관세사로 납부)</div>
						<div class="mt5">●	사업자 영리 목적으로 구매하실 경우
						<br><span style="color:#888;"> - 구매금액 수량 등은 제한없음</span>
						<br><span style="color:#888;"> - 모든 수입물품의 원산지 표기 필수</span>
						<br><span style="color:#888;"> - 모관부가세 및 기타비용이 발생합니다.</span>
						</div>
						<div class="mt5" style="font-weight: 600;">●	통관 주의사항	<br class="visible-xs">
								<router-link to="/bizCustomsInfo" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 목록통관 취하</div>
					<div class="card-body">
						<div class="mt5">●	6,500원</div>
						<div class="mt5">●	목록통관 세관 통관 취하로 발생되는 비용입니다.</div>
						<div class="mt5">●	목록통관 취하 수수료 2,000원 + 간이통관 수수료 3,000원 + (인천항창고관리비)포장당1,500원</div>
						<div class="mt5">●	$2000 초과 시 간이통관수수료3.000원이 관세사비용 11,000원으로 변경청구됩니다</div>
						<div class="mt5">●	신청서 작성 시, 신고 내용을 정확히 입력하셔야 합니다.</div>						
						<div class="mt5" style="font-weight: 600;">●	통관 주의사항	<br class="visible-xs">
								<router-link to="/bizCustomsInfo" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 분할/폐기 수수료</div>
					<div class="card-body">
						<div class="mt5">●	11,000원(관세사로 납부)</div>
						<div class="mt5">●	세관 통관 금지 품목이 일부 포함되었을 경우 발생되는 분할/폐기수수료입니다.</div>
						<div class="mt5">●	통관 금지 품목만 폐기가 진행됩니다.</div>
						<div class="mt5">●	전체 통관 금지 품목일 경우, 세관 요청 증빙 자료 미제출로 인해 통관 포기/전체 폐기 요청 시,  전체 세관 자체 폐기(무료)</div>					
						<div class="mt5" style="font-weight: 600;">●	통관 주의사항	<br class="visible-xs">
								<router-link to="/bizCustomsInfo" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 보세창고료</div>
					<div class="card-body">
						<div class="mt5">●	실비(관세사로 납부)</div>
						<div class="mt5">●	통관 지체 사유로 10일 이상 세관 보세창고 보관 시 실비청구</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 식물 검역 수수료</div>
					<div class="card-body">
						<div class="mt5">●	11,000원(관세사로 납부)</div>
						<div class="mt5">●	품종에 따라 수수료 상이</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">8. 동물 검역 수수료</div>
					<div class="card-body">
						<div class="mt5">●	5,500원(관세사로 납부)</div>
						<div class="mt5">●	품종에 따라 수수료 상이</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">9. C/O(원산지 증명)</div>
					<div class="card-body">
						<div class="mt5">●	35,000원</div>
						<div class="mt5">●	최대 20개 품목 적용</div>
						<div class="mt5">●	과 시 추가발급비용 발생</div>
						<div class="mt5">●	한중 FTA에 따른 $700 이하 수입 시에도 세관의 원산지 증명서를 제출해야 합니다.</div>
						<div class="mt5">●	신청서 작성 시, 상품 별 HS 코드를 [요청사항]란에 필수로 입력주셔야 합니다.</div>
						<div class="mt5" style="font-weight: 600;">●	원산지작업 C/O 주의사항	<br class="visible-xs">
								<!-- <router-link to="/" class="link-btn type-2">
									바로가기 <i class="el-icon-top-right"></i>
								</router-link> -->
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">10. 수취인 변경</div>
					<div class="card-body">
						<div class="mt5">●	배송요청 이전 무료</div>
						<div class="mt5">●	배송요청 이후 포장완료된 박스당 1,000원</div>
						<div class="mt5">●	출고 이후 7,000원 + 박스당 2,000원 청구됩니다.</div>
					</div>
				</div>
			</div>
			<div class="tab-content" v-if="up_active==1&&active==5">
				<div class="tab-title">
					반송
				</div>
				<div class="type-card">
					<div class="card-head">1. 반송</div>
					<div class="card-body">
						<div class="mt5">●	반품수수료(판매자별)</div>
						<div class="mt5">●	3,500원+반품 택배비 실비</div>
						<div class="mt5">●	무료반품이 아닌 경우 반품 택배비가 청구됩니다.</div>
						<div class="mt5">●	판매처 오배송 사유로 남겨주실 경우 수수료 면제돼요.</div>
						<div class="mt5">●	반품 수수료 및 택배비는 고로켓고 적용 환율로 청구됩니다.</div>
						<div class="mt5">●	착불 반품 접수시 : 판매처 동의 하에 접수바랍니다. 판매처 수취 거부 시, 왕복 택배비 고객님 부담입니다.</div>
					</div>
				</div>
			</div>
			<div class="tab-content" v-if="up_active==1&&active==6">
				<div class="tab-title">
					원산지 작업/보관
				</div>
				<div class="type-card">
					<div class="card-head">1. 현지보관료</div>
					<div class="card-body">
						<div class="mt5">●	첫 번째 도착된 상품 기준으로 90일 무료 보관</div>
						<div class="mt5">●	도착 90일 경과 시, 임의 폐기 처리됩니다.</div>
						<div class="mt5">●	노데이터 상품은 도착 30일후 임의 폐기처리 됩니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 재고보관</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	중국현지 물품보관, 재고관리 등 복잡하고 비용이 부담이 되는 업무를 고로켓고에 맡기고 판매에만 집중하세요.</div>
						<div class="mt5">●	중국 판매자로부터 구매하신 상품을 고로켓고 중국 현지 센터에 재고보관하여 사업자 회원님의 고객 주문 시 수령지로 발송해드리는 서비스입니다.</div>
						<div class="mt5" style="font-weight: 600;">●	재고보관	<br class="visible-xs">
							<router-link to="/inventoryGuide" class="link-btn type-2">
								바로가기 <i class="el-icon-top-right"></i>
							</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 스티커</div>
					<div class="card-body">
						<div class="mt5">●	30개 이하 3,000원</div>
						<div class="mt5">●	30개 이상 개당 80원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 도장</div>
					<div class="card-body">
						<div class="mt5">●	30개 이하 3,000원</div>
						<div class="mt5">●	30개 이상 개당 80원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 봉제</div>
					<div class="card-body">
						<div class="mt5">●	개당 300원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 택/라벨 제거</div>
					<div class="card-body">
						<div class="mt5">●	30개 이하 2,000원</div>
						<div class="mt5">●	30개 이상 개당 50원</div>
						<div class="mt5">●	모든 수입물품의 원산지 표기 필수입니다</div>
					</div>
				</div>
			</div>
			<div class="tab-content" v-if="up_active==1&&active==7">
				<div class="tab-title">
					기타
				</div>
				<div class="type-card">
					<div class="card-head">1. 자동 배송 요청 서비스</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	신청서 상 모든 아이템들이 도착 처리로 변경될 경우 자동으로 [배송요청] 접수되어 포장을 해드려요.</div>
						<div class="mt5">●	[배송요청] 접수된 이후 요청 사항에는 "재포장" 옵션 수수료가 발생될 수 있어요.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 사업자 팀머니 자동 결제 서비스</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
						<div class="mt5">●	사업자 팀머니가 충전되어 있을 경우 매번 결제창을 통하지 않고 배송비 결제 요청 시 자동으로 결제됩니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 국내택배 할증 요금표</div>
					<div class="card-body">
						<div class="mt5">●	국내택배사 할증기준 배송신청서당</div>
						<div class="mt5">●	포장완료된 상태로 아래 기준으로 국제배송비외 추가로 청구됩니다.</div>
						<table border="1" cellspacing="0" style="border-color: #eee;">
							<colgroup>
								<col width="150">
								<col width="150">
								<col width="150">
							</colgroup>
							<tbody>
							<tr>
								<td>80cm 미만</td>
								<td>2kg 미만</td>
								<td>무료</td>
							</tr>
							<tr>
								<td>80~100cm 미만</td>
								<td>5kg 미만</td>
								<td>600원</td>
							</tr>
							<tr>
								<td>100~120cm 미만</td>
								<td>5~10kg 미만</td>
								<td>1,200원</td>
							</tr>
							<tr>
								<td>120~140cm 미만</td>
								<td>10~15kg 미만</td>
								<td>3,000원</td>
							</tr>
							<tr>
								<td>140~160cm 미만</td>
								<td>15~20kg 미만</td>
								<td>3,500원</td>
							</tr>
							</tbody>
						</table>
						<div class="mt5">●	삼변합/무게 중 큰 값으로 적용됩니다.</div>
						<div class="mt5">●	배송비 청구 시 자동으로 청구됩니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 합배송(신청서합치기)</div>
					<div class="card-body">
						<div class="mt5">●	如여러 개 신청서를 하나의 신청서로 합배송 진행을 원하시는 경우 합배송이 가능합니다.</div>
						<div class="mt5">
							<img loading="lazy"  src="../../assets/list/accept.png" alt="" class="img-responsive ">
						</div>
						<div class="mt5">●	배송요청 접수된 신청서부터 합배송 요청 시, 배송요청 신청서 당 재포장 수수료 5,000원 발생합니다.</div>
						<div class="caution">
							<strong>※ 주의사항</strong>
							<ul class="num-list">
								<li>신청서 합배송 전 면세범위를 확인하시기 바랍니다.</li>
								<li>취소(나누기) : 마이페이지 > 나누기 대상 신청서 선택 > 분할가능 상품 선택 > 나누기<br>
								합배송 신청 후 미도착(미입고) 상품은 나누기 분할 가능하나, 이미 도착 된 상품은 취소(나누기)가 불가능하기 때문에 신중하게 신청 부탁드립니다.
								</li>
								<li>타 계정 상품과는 합배송 불가능합니다.</li>
								<li>도착된 상품을 합배송 신청하신 경우 다시 재분할이 불가하오니 신중하게 신청해주시기 바랍니다.</li>
							</ul>
						</div>
						<div class="mt5">●	위 내용 미숙지로 인한 불이익은 고로켓고의 책임이 없는 점 안내드립니다.</div>
						<div class="mt5">●	삭제 : 로그인 > 마이페이지 > 배송신청 > 해당하는 신청번호 선택 > 삭제버튼 클릭 </div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 항공선적불가 상품</div>
					<div class="card-body">
						<div class="mt5">●	신청서당 1,000원</div>
						<div class="mt5">●	항공선적 불가상품이 포함된 신청서 포장으로 인해 선적거부로 고로켓고 현지센터로 리턴되는 수수료</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. CCTV 영상요청</div>
					<div class="card-body">
						<div class="mt5">●	5,000원</div>
						<div class="mt5">●	고로켓고의 실수가 의심되는 누락/분실 등과 기타 사유로 영상 확인이 필요할 경우</div>
						<div class="mt5">●	상품 수령 후 3일 이내 요청하셔야 하며, 첫 상품 입고 3주 경과 시 요청 불가합니다.</div>
						<div class="mt5">●	CCTV로도 작은 물품은 확인하기 어려울 수 있습니다.</div>
						<div class="mt5">●	누락/분실이 확인되는 경우 영상 요청 비용 및 재발송 또는 구매 비용을 보상해 드립니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 배송신청서 트래킹번호 추가비용</div>
					<div class="card-body">
						<div class="mt5">●	1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지)까지 무료</div>
						<div class="mt5">●	1개의 배송신청서 상 서로 다른 트래킹 번호 5 (가지) 초과 시, 추가된 트래킹번호 1가지 당 500원 청구</div>
						<div class="mt5">●	예) 신청서 A 아이템번호 6가지, 한 가지 트래킹번호일 경우 (수수료 발생 X)</div>
						<div class="mt5">●	예) 신청서 B 아이템번호 6가지, 6가지 트래킹번호일 경우 (수수료 발생 O)</div>
					</div>
				</div>		
			</div>
			<div class="tab-content" v-if="up_active==2&&active==1">
				<div class="tab-title">
					검수
				</div>
				<div class="type-card">
					<div class="card-head">1. 검수안함</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 수량 검수</div>
					<div class="card-body">
						<div class="mt5">●	개당 80원</div>
						<div class="mt5">●	도착된 전체 상품의 수량을 검수해 드립니다.</div>
						<div class="mt5">●	신청서상의 상품 전체원산지 작업 시 수량검수 무료</div>
						<table border="1" cellspacing="0" style="border-color: #eee;">
							<colgroup>
								<col width="150">
								<col width="150">
							</colgroup>
							<tbody>
							<tr>
								<td>전체 파손/수량 검수</td>
								<td>개당 200원</td>
							</tr>
							<tr>
								<td>랜덤 파손/수량 검수</td>
								<td>개당 800원</td>
							</tr>						
							</tbody>
						</table>
						<p>1.원산지작업 진행회원님은 50%할인</p>
						<p>2.상품 전체의 파손/수량을 검수합니다.</p>
						<p>3.랜덤 파손 건수는 요청하신 수량만큼 육안 검수 완료 후의 사진을 제공해 드립니다.</p>
						<p>검수 중 이상이 발견되면 회원님께 안내를 드립니다.</p>
						<div class="mt5" style="font-weight: 600;">●	사진은 이렇게 제공해 드려요.	<br class="visible-xs">
							<router-link to="/questionList" class="link-btn type-2">
								바로가기 <i class="el-icon-top-right"></i>
							</router-link>
						</div>
					</div>
				</div>	
			</div>
			<div class="tab-content" v-if="up_active==2&&active==2">
				<div class="tab-title">
					포장
				</div>
				<div class="type-card">
					<div class="card-head">1. 포장안함</div>
					<div class="card-body">
						<div class="mt5">●	무료</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 박스비용</div>
					<div class="card-body">
						<div class="mt5">●	박스로 포장이 필요하실 경우 박스 개당 비용입니다.</div>
						<div class="mt5">●	삼변의 합</div>
						<table border="1" cellspacing="0" style="border-color: #eee;">
							<colgroup>
								<col width="150">
								<col width="150">
							</colgroup>
							<tbody>
							<tr>
								<td>80cm 이하</td>
								<td>500원</td>
							</tr>
							<tr>
								<td>100cm 이하</td>
								<td>1,000원</td>
							</tr>
							<tr>
								<td>120cm 이하</td>
								<td>1,500원</td>
							</tr>
							<tr>
								<td>140cm 이하</td>
								<td>2,000원</td>
							</tr>
							<tr>
								<td>160cm 이하</td>
								<td>2,500원</td>
							</tr>
							<tr>
								<td>160cm 이하</td>
								<td>비용상이</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 마대비용</div>
					<div class="card-body">
						<div class="mt5">●	장당 중 2,000원 대 3,500원</div>
						<div class="mt5">●	훼손/오염/스크래치 등이 발생할 수 있습니다.</div>
						<div class="mt5">●	박스포장이 어렵거나 이형화물 등의 포장 시</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 폴리백 비용</div>
					<div class="card-body">
						<div class="mt5">●	일반형 장당 300원 / 중형 장당 500원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 밴딩 작업</div>
					<div class="card-body">
						<div class="mt5">●	파렛트 당  3,000원</div>
						<div class="mt5">●	밴딩 작업이 필요하신 경우 작업해 드립니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 수출용 파렛트 비용</div>
					<div class="card-body">
						<div class="mt5">●	개당 25,000원</div>
						<div class="mt5">●	검역통관 가능한 파렛트입니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 랩핑비용</div>
					<div class="card-body">
						<div class="mt5">●	파렛트 당 5,000원</div>
						<div class="mt5">●	파렛트 이용 시 신청가능합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">8. 목재 포장비용</div>
					<div class="card-body">
						<div class="mt5">●	실비</div>
						<div class="mt5">●	부피가 큰 상품 파손 위험이 높은 상품 등을 목재 포장해 드려요.</div>
						<div class="mt5">●	현지 판매처에서 통관이 불가능한 목재 포장으로 도착 시, 해제하여 (해체비용 자동청구) 검역 문제가 없는 목재 포장으로 진행됩니다.</div>
						<div class="mt5">●	제품 크기에 따라 소요 시간과 비용이 달라요.</div>
						<div class="mt5">●	목재 포장 접수 이후에는 포장 취소 접수가 불가합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">9. 목재 포장 제거비용</div>
					<div class="card-body">
						<div class="mt5">●	도착된 목재 포장 삼변합 1.5m 이내 기준 3,000원</div>
						<div class="mt5">●	추가 10cm 당 500원 청구됩니다.</div>
						<div class="mt5">●	도착된 목재 포장의 경우, 검역 통과 불가한 목재 포장의 경우 제거 후 자동 청구드려요.</div>
						<div class="mt5">●	검역통관 가능 목재 포장은 고객센터 문의로 사전 요청해주시면 제거하지 않습니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">10. 쿠팡 로켓그로스</div>
					<div class="card-body">
						<div class="mt5">●	파렛트,랩핑 (쿠팡납품용 Kpp혹은 AJ 파렛트) *사전 고객센터로 문의주세요*</div>
						<div class="mt5">●	파렛트 + 랩핑 30,000원</div>
						<div class="mt5">●	바코드 스티커 개당 100원</div>
						<div class="mt5">●	문서 A4 장당 200원</div>
						<div class="mt5">●	바코드 및 관련 문서는 파일로 제공해 주셔야 합니다. 필요하신 부분만 요청가능합니다.</div>
						<div class="mt5">●	통관완료 후 한국 내 보관이 필요하실 경우 고객센터로 문의 바랍니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">11. OPP비닐봉투</div>
					<div class="card-body">
						<div class="mt5">●	소100원 / 중 150원 / 대 200원</div>
						<div class="mt5">●	벌크로 입고된 상품의 비닐포장용 자재비용</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">12. 바코드 스티커</div>
					<div class="card-body">
						<div class="mt5">●	각종 바코드 스티커 소형 100원</div>
						<div class="mt5">●	바코드 스티커 부착이 필요하신 경우 바코드 자료를 제공해주셔야 작업 가능합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">13. 문서 출력비용</div>
					<div class="card-body">
						<div class="mt5">●	A4 장당 200원</div>
						<div class="mt5">●	각종 문서 출력 비용</div>
						<div class="mt5">●	자료를 제공해주셔야 합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">14. 감사템플릿 동봉</div>
					<div class="card-body">
						<div class="mt5">●	장당 200원</div>
						<div class="mt5" style="font-weight: 600;">●	감사 템플릿 동봉 서비스	<br class="visible-xs">
							<router-link to="/questionList" class="link-btn type-2">
								바로가기 <i class="el-icon-top-right"></i>
							</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">15. 한글설명서 동봉</div>
					<div class="card-body">
						<div class="mt5">●	A4 장당 200원</div>
						<div class="mt5">●	한글설명서 동봉 서비스 파일 제공해주셔야 합니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">16. 환불금지 스티커</div>
					<div class="card-body">
						<div class="mt5">●	장당 100원</div>
						<div class="mt5">●	개봉 시 환불금지 스티커 부착 서비스</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">17. 재포장 비용</div>
					<div class="card-body">
						<div class="mt5">●	포장당 2,000원 + 포장자재비용</div>
						<div class="mt5">●	포장완료된 기존포장을 해체 재포장하는 비용입니다.</div>
						<div class="mt5">●	배송비 결제 이후에는 요청 불가합니다.</div>
						<div class="mt5">●	고객센터 문의 요청 후 진행합니다.</div>					
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">18. 인증라벨 부착</div>
					<div class="card-body">
						<div class="mt5">●	장당 100원</div>
						<div class="mt5">●	각종 인증스티커 부착이 필요할 경우 라벨 자료를 제공해 주셔야 합니다.</div>				
					</div>
				</div>		
			</div>
			<div class="tab-content" v-if="up_active==2&&active==3">
				<div class="tab-title">
					원산지 작업/보관
				</div>
				<div class="type-card">
					<div class="card-head">1. 스티커</div>
					<div class="card-body">
						<div class="mt5">●	30개 이하 3,000원</div>
						<div class="mt5">●	30개 이상 개당 80원</div>				
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. 도장</div>
					<div class="card-body">
						<div class="mt5">●	30개 이상 개당 80원</div>
						<div class="mt5">●	30개 이상 개당 80원</div>				
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. 봉제</div>
					<div class="card-body">
						<div class="mt5">●	개당 300원</div>			
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 택/라벨 제거</div>
					<div class="card-body">
						<div class="mt5">●	30개 이하 2,000원</div>
						<div class="mt5">●	30개 이상 개당 50원</div>	
						<div class="mt5">●	모든 수입물품의 원산지 표기 필수입니다</div>	
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 현지보관료</div>
					<div class="card-body">
						<div class="mt5">●	첫번째 도착된 상품 기준으로 90일 무료 보관</div>
						<div class="mt5">●	도착 90일 경과 시, 임의 폐기 처리됩니다.</div>	
						<div class="mt5">●	노데이터 상품은 도착 30일후 임의 폐기처리 됩니다.</div>	
					</div>
				</div>
			</div>
			<div class="tab-content" v-if="up_active==2&&active==4">
				<div class="tab-title">
					통관
				</div>
				<div class="type-card">
					<div class="card-head">1. 사업자 수입통관</div>
					<div class="card-body">
						<div class="mt5">●	관세사 비용 30,000원 (관세사로 납부)</div>
						<div class="mt5">●	사업자 영리목적으로 구매하실 경우 구매금액, 수량 등은 제한없음</div>	
						<div class="mt5">●	모든 수입물품의 원산지 표기 필수이며, 인증상품은 관련 인증도 필요합니다.</div>
						<div class="mt5">●	관부가세 및 통관기간 품목에 따라 기타비용이 발생합니다.</div>
						<div class="mt5" style="font-weight: 600;">●	통관주의사항	<br class="visible-xs">
							<router-link to="/bizCustomsInfo" class="link-btn type-2">
								바로가기 <i class="el-icon-top-right"></i>
							</router-link>
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">2. D/O(Delivery Order)</div>
					<div class="card-body">
						<div class="mt5">●	발행 수수료 19,000원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">3. C/O(원산지 증명서)</div>
					<div class="card-body">
						<div class="mt5">●	35,000원</div>
						<div class="mt5">●	최대 20개 품목 적용</div>
						<div class="mt5">●	초과 시 추가발급비용 발생</div>
						<div class="mt5">●	한중 FTA에 따른 $700 이하 수입 시에도 세관의 원산지 증명서를 제출해야 합니다.</div>
						<div class="mt5">●	신청서 작성 시, 상품 별 HS 코드를 [요청사항]란에 필수로 입력주셔야 합니다.</div>
						<div class="mt5" style="font-weight: 600;">●	원산지작업 C/O 주의사항	<br class="visible-xs">
							<!-- <router-link to="/" class="link-btn type-2">
								바로가기 <i class="el-icon-top-right"></i>
							</router-link> -->
						</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">4. 화물작업비</div>
					<div class="card-body">
						<div class="mt5">●	기본 1 CBM 까지 9,000원</div>
						<div class="mt5">●	추가 0.1 CBM 당 900원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">5. 선적항 운송료</div>
					<div class="card-body">
						<div class="mt5">●	기본 1 CBM 까지 9,000원</div>
						<div class="mt5">●	추가 0.1 CBM 당 900원</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">6. 관/부가세</div>
					<div class="card-body">
						<div class="mt5">●	실비</div>
						<div class="mt5">●	해당 품목 관부세율에 따릅니다.</div>
						<div class="mt5">●	반입 이후 장기간 보관 시 창고료가 발생됩니다. 반입이후 +1일 이내 출고 진행바랍니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">7. 식물검역수수료</div>
					<div class="card-body">
						<div class="mt5">●	11,000원 (관세사로 납부)</div>
						<div class="mt5">●	품종에 따라 수수료 상이</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">8. 동물검역수수료</div>
					<div class="card-body">
						<div class="mt5">●	5,500원 (관세사로 납부)</div>
						<div class="mt5">●	품종에 따라 수수료 상이</div>
						<div class="mt5">●	관/부가세 - 해당 품목 관부세율에 따릅니다.</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">9. 국내 화물차</div>
					<div class="card-body">
						<div class="mt5">●	실비</div>
					</div>
				</div>
				<div class="type-card">
					<div class="card-head">10. 수출환급</div>
					<div class="card-body">
						<div class="mt5">●	48,000원</div>
						<div class="mt5">●	제조공장에서 수출환급을 원하는 경우는 중국어로 된 인보이스 + 패킹리스트 + 수출신고서(申报要素)가 필요합니다.</div>
						<div class="mt5">●	사전에 판매업체와 회원님 간의 협의가 되어 있어야 하며, 제조공장(수출자)와 회원님 간 협의 없이 고로켓고에게 연락이 올 경우 회원님과 먼저 협의 진행요청을 해달라고 전달을 해드립니다.</div>
						<div class="mt5">●	제공된 정보가 부족 시 수출환급 진행 없이 출고될 수 있습니다.</div>
					</div>
				</div>	
			</div>
			<div class="tab-content" v-if="up_active==2&&active==5">
				<div class="tab-title">
					반송
				</div>
				<div class="type-card">
					<div class="card-head">1. 반송</div>
					<div class="card-body">
						<div class="mt5">●	반송수수료 (판매자별)</div>
						<div class="mt5">●	반송수수료 3,500원 + 반품택배비 실비</div>
						<div class="mt5">●	무료반품이 아닌 경우 반품 택배비가 청구됩니다.</div>
						<div class="mt5">●	판매처 오배송 사유로 남겨주실 경우 수수료 면제돼요.</div>
						<div class="mt5">●	반품 수수료 및 택배비는 고로켓고 적용 환율로 청구됩니다..</div>
						<div class="mt5">●	착불 반품 접수 시 : 판매처 동의하에 접수바랍니다. 판매처 수취 거부 시, 왕복 택배비 고객님 부담입니다.</div>
					</div>
				</div>	
			</div>
			<div class="tab-content" v-if="up_active==2&&active==6">
				<div class="tab-title">
					기타
				</div>
				<div class="type-card">
					<div class="card-head">1. CCTV 영상요청</div>
					<div class="card-body">
						<div class="mt5">●	5,000원</div>
						<div class="mt5">●	고로켓고의 실수가 의심되는  누락/분실 등과 기타 사유로 영상확인이 필요할 경우 상품 수령 후 3일 이내 요청하셔야 하며, 첫 상품 입고 3주 경과 시 요청 불가합니다. </div>
						<div class="mt5">●	CCTV로도 작은 물품은 확인하기 어려울 수 있습니다.</div>
						<div class="mt5">●	누락/분실이 확인되는 경우 영상요청비용과 구매 비용을 보상해 드립니다.</div>
					</div>
				</div>	
			</div>
			<div class="check-list-wrap">
				<ul class="check-list">
					<li>육안 검수 후 실사를 제공해드리며 검수 옵션에 따라 제공된 실사가 검수로 대체되오니 회원님께서 확인해주셔야 합니다. 이상 발견 시 회원님께 즉시 알림톡 안내를 드립니다.</li>
					<li>검수로 확인이 어려운 미세 스크래치, 오염, 훼손, 올풀림, 구성품 확인 불가 등이 발생할 수&nbsp; 있으며 이는 보상대상이 아닙니다</li>
					<li>검수를 위한 개봉 혹은 목재포장 개봉으로 인한 상품 가치 하락/훼손/오염 /구성품의 분실 등이 발생할 수 있으며 이는 보상 대상이 아닙니다.</li>
					<li>별도의 요청이 없으신 경우, 포장 담당자 재량의 따라 배송중량 절감을 위해 불필요한 현지 포장들은 무료 제거 후 포장이 진행됩니다.</li>
					<li>제품 분실/파손 등 우려가 있는 상품들은 현지 포장 제거 없이 발송될 수 있습니다.</li>
					<li>현지 업무량에 따라 포장 제거되지 않을 수 있으며 이로 인한 배송비 차액은 환불대상이 아닙니다.</li>
					<li>포장보완을 신청하지 않을 경우, 파손 시 각종 보상에서 제외됩니다.</li>
					<li>사업자 통관일 경우 원산지 작업은 필수사항입니다.</li>
				</ul>
			</div>
		</div>	
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	export default {
		components: {
			BusinessBanner
		},
		data() {
			return{
				up_active:1,
				active:1 
			}
		},
		methods: {
			onUpTab(index){
				this.up_active = index
				this.active = 1	
			},
			onTab(index){
				console.log(index)
				this.active = index		
			},
			onCurrentNav(url){
				this.$router.push(url);
				
			},
		}
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.tab{
		background: #FFFFFF;
		border: 1px solid #E8E8E8;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		font-weight: 600;
		font-size: 24px;
		color: #303030;
		line-height: 56px;
		transition: 0.25s;
		text-align: center;
		text-decoration: none;
		cursor: pointer;
		margin:0 10px 15px;
	}
	.tab:hover,.active{
		color: #fff;
		background: #303030;
	}
	.tab-content{
		border-radius: 20px;
		background: #FFFFFF;
		border: 1px solid #E8E8E8;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		padding:20px;	
	}
	.tab-title{
		font-size: 28px;
		font-weight: bold;
		padding: 20px 30px 20px 40px;
		color: var(--background-color);
	}
	.type-card{
		border: 1px solid #DDDDDD;
		border-radius: 10px;
		box-shadow: none;
		margin: 0 40px 20px;
	}
	.card-head {
		background: #D5E6FA;
		border-bottom: 1px solid #E8E8E8;
		font-weight: 700;
		font-size: 20px;
		line-height: 49px;
		color: #111111;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		height: 49px;
		justify-content: flex-start;
		padding: 0 17px;
	}
	.card-body{
		padding: 17px 30px;
		font-size: 15px;
		color: var(--background-color);
	}
	.card-body .mt5{
		padding: 5px 0;
	}
	.caution{
		padding: 10px;
		background-color: var(--border-color);
		border-radius: 10px;
	}
	.num-list{
		padding: 0 20px;
	}
	.check-list-wrap{
		padding: 0 50px;
	}
	ul.check-list{
		margin: 40px 0;
		padding: 0;
		list-style: none;
	}
	ul.check-list li {
	    padding-left: 26px;
	    background: url('../../assets/ico_check_grey.svg') no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 15px;
	    line-height: 27px;
	}
	
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.link-btn{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.visible-xs {
	    display: none !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.tab{
			font-size: 14px;
			margin:0 8px 12px;
		}
		.tab-content{
			margin: 20px;
		}
		.type-card{
			margin: 0 6px 10px;
		}
		
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
	
</style>